import React from "react";
import { motion } from "framer-motion";
import { integrations } from "../Data";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const IntegrationLogos = () => {
  return (
    <section className="integrations-section">

      {/* Heading */}
      <motion.h2
        className="section-heading"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        Seamless WhatsApp Integrations with{" "}
        <span>Your Favorite Business Apps</span>
      </motion.h2>

      {/* Integration Grid */}
    <div className="integrations-grid">

  {integrations.slice(0, 4).map((item, i) => (
    <motion.div
      className="integration-card"
      key={i}
      variants={fadeUp}
      whileHover={{ y: -6 }}
      transition={{
        duration: 0.25,
        ease: "easeOut",
      }}
    >
      <div className="integration-icon">
        <img
          src={item.img}
          alt={`${item.name} | Onbbits`}
        />
      </div>

      <span className="section-text">
        {item.name}
      </span>
    </motion.div>
  ))}

</div>

<div className="integrations-grid integrations-grid-second">

  {integrations.slice(4).map((item, i) => (
    <motion.div
      className="integration-card"
      key={i}
      variants={fadeUp}
      whileHover={{ y: -6 }}
      transition={{
        duration: 0.25,
        ease: "easeOut",
      }}
    >
      <div className="integration-icon">
        <img
          src={item.img}
          alt={`${item.name} | Onbbits`}
        />
      </div>

      <span className="section-text">
        {item.name}
      </span>
    </motion.div>
  ))}

</div>

    </section>
  );
};

export default IntegrationLogos;